var render = function render(){var _vm=this,_c=_vm._self._c;return (this.$route.params.jenis=='TMA')?_c('span',[_c('NotificationPetugasTMAVue')],1):_c('span',[_c('NotificationPetugasOmbroVue')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }